<template>
  <section v-if="fields.length" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Profile completeness</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">
      Share of verified members who filled in each profile field<span v-if="totalVerified"> ({{ totalVerified }} members)</span>.
    </p>

    <div class="space-y-3">
      <div v-for="field in fields" :key="field.label">
        <div class="tw-flex items-center justify-between text-sm mb-1">
          <span class="text-gray-600">{{ field.label }}</span>
          <span class="text-gray-400">{{ field.percentage }}%</span>
        </div>
        <div class="h-2 rounded-full bg-gray-100 overflow-hidden">
          <div class="h-full rounded-full bg-primary" :style="{ width: field.percentage + '%' }"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'HeartbeatProfileCompleteness',
    props: {
      users: Object,
    },
    computed: {
      fields () {
        return (this.users && this.users.profile_completeness) || []
      },
      totalVerified () {
        return this.users && this.users.total_verified_users
      },
    },
  }
</script>
